define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/_base/modules",
	"csi/def/Field",
	"csi/html",
	"csi/table/New",
	"csi/xml",
	"./ProductType"
], function(declare,lang,def,modules,Field,html,New,xml,ProductType) {

	return declare(New, {
		SUPPLIER: "Supplier",
		// to indicate if the form is from site level
		isFromSiteLevel: false,
		/**
		 * Customize material sample form
		 */
		onCreatePopupDefView: function(defView) {
			var	fields = defView.m_fields;
			var	product = this.getParent();

			if (product.$Type == "Material") {
				// remove color/size field(s) based on material type
				if (ProductType.hasColor(product)) {
					fields.push(lang.mixin(new Field(), {m_id: "ProductColor"}));
				}

				if (ProductType.hasSize(product)) {
					fields.push(lang.mixin(new Field(), {m_id: "ProductSize"}));
				}
			} else if (product.$Type == "ColorMaterial") {
				// add size field based on material type
				product = this.m_cache.getNode(product.__Parent__, true);

				if (ProductType.hasSize(product)) {
					fields.push(lang.mixin(new Field(), {m_id: "ProductSize"}));
				}
			} else {
				// add Material Type and Name if create sample outside context of material - only allow standalone material types
				fields.push(lang.mixin(new Field(), {
					m_id: "DimensionType",
					m_path: "Child:ProductSize",
					idParameter: "ProductSizeDimType"
				}));

				// summary: add material security group field to form
				fields.push(lang.mixin(new Field(), {
					m_id: "MaterialSecurityGroups",
					idParameter: "MaterialSecurityGroups",
					m_path: "Child:__Parent__/Child:__Parent__/Child:__Parent__"
				}));

				// splice in Material Type at 5th position (so it comes up just before Colors / Sizes)
				fields.splice(6, 0, lang.mixin(new Field(), {
					m_id: "ProductType",
					m_path: "Child:__Parent__/Child:__Parent__/Child:__Parent__"
				}));

				fields.push(lang.mixin(new Field(), {
					m_label: "MaterialName",
					idParameter: "MaterialName"
				}));

				// add Material Type, Name, and Color selection before ProductColor field (if it exists)
				fields.push(lang.mixin(new Field(), {
					m_id: "ColorSpecification",
					m_path: "Child:ProductColor",
					m_class: html.CSS_HIDE,
					m_onChange: "onChangeColorSpecification"
				}));
			}

			// add supplier
			if (modules.hasModule("Sourcing")) {
				const sourcefield = lang.mixin(new Field(), {
					m_label: this.SUPPLIER,
					m_id: "ProductSources",
					m_path: xml.path(xml.ATTR_PARENT, xml.ATTR_PARENT),
					m_bRequired: true,
					omitFromReport: true
				})
				fields.unshift(sourcefield);
				if(this.isFromSiteLevel) {
					sourcefield.m_typeControl = def.FIELD_FILTERING_SELECT;
					sourcefield.m_type = xml.ATTR_REF;
				}
			}

			// add controller class for form to manage action
			defView.classController = "Apparel.NewMaterialSampleForm";
		}

	});
});